import { DependentRelationship } from '@taxfyle/txf-api-client'

export const DEPENDENT_RELATIONSHIPS_MAP: Record<
  DependentRelationship,
  string
> = {
  [DependentRelationship.Son]: 'Son',
  [DependentRelationship.Daughter]: 'Daughter',
  [DependentRelationship.FosterChild]: 'Foster Child',
  [DependentRelationship.GrandChild]: 'Grand Child',
  [DependentRelationship.StepChild]: 'Step Child',
  [DependentRelationship.GrandParent]: 'Grand Parent',
  [DependentRelationship.Parent]: 'Parent',
  [DependentRelationship.Brother]: 'Brother',
  [DependentRelationship.HalfBrother]: 'Half Brother',
  [DependentRelationship.StepBrother]: 'Step Brother',
  [DependentRelationship.Sister]: 'Sister',
  [DependentRelationship.HalfSister]: 'Half Sister',
  [DependentRelationship.StepSister]: 'Step Sister',
  [DependentRelationship.Aunt]: 'Aunt',
  [DependentRelationship.Uncle]: 'Uncle',
  [DependentRelationship.Nephew]: 'Nephew',
  [DependentRelationship.Niece]: 'Niece',
  [DependentRelationship.Other]: 'Other',
} as const

export const DEPENDENT_RELATIONSHIPS = Object.entries(
  DEPENDENT_RELATIONSHIPS_MAP,
) as [code: DependentRelationship, label: string][]
